import { render, staticRenderFns } from "./healthprogram.vue?vue&type=template&id=c13230b2&scoped=true&"
import script from "./healthprogram.vue?vue&type=script&lang=js&"
export * from "./healthprogram.vue?vue&type=script&lang=js&"
import style0 from "./healthprogram.vue?vue&type=style&index=0&id=c13230b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13230b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c13230b2')) {
      api.createRecord('c13230b2', component.options)
    } else {
      api.reload('c13230b2', component.options)
    }
    module.hot.accept("./healthprogram.vue?vue&type=template&id=c13230b2&scoped=true&", function () {
      api.rerender('c13230b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/healthprogram.vue"
export default component.exports